const UUID_STORAGE_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(\.[a-z0-9]+)?$/i;

export const formatStorageDisplayName = (item, kind) => {
  const raw = (item?.fileName || item?.objectKey || "").trim();
  if (!raw) {
    return "Senza nome";
  }
  if (kind === "image") {
    const name = (item?.fileName || "").trim();
    if (name) {
      return name;
    }
    const slash = raw.lastIndexOf("/");
    return slash >= 0 ? raw.substring(slash + 1) : raw;
  }
  const base = raw.replace(/\.json$/i, "");
  if (UUID_STORAGE_PATTERN.test(raw) || UUID_STORAGE_PATTERN.test(`${base}.json`)) {
    return "Elemento salvato";
  }
  return base;
};
 